import { renderBlock } from '../../../common/helpers/didYouKnowHelper';
import i10n from '../../../common/i10n';

export const renderFirstColumnWithAddedLink = () =>
    <div>{i10n._VIEW_OCR_DIDYOUKNOW_COLUMN_1_DESC_ALL} {renderBlock(i10n._VIEW_OCR_DIDYOUKNOW_COLUMN_1_DESC_LINK.toLowerCase(), { type: 'link', href: 'https://www.orpalis.com/blog/optical-character-recognition-an-introduction/' })}</div>


export const renderSecondColumnWithAddedLink = () =>
    <div>{i10n._VIEW_OCR_DIDYOUKNOW_COLUMN_2_DESC_1_PART_1} {renderBlock(i10n._VIEW_OCR_DIDYOUKNOW_COLUMN_2_DESC_1_PART_2.toLowerCase(), { type: 'link', href: 'https://www.orpalis.com/blog/optical-character-recognition-some-advices/' })} {i10n._VIEW_OCR_DIDYOUKNOW_COLUMN_2_DESC_1_PART_3}</div>